export default __webpack_public_path__ + "static/media/OE_QuestForwardLearningTM_forDark.51964cf3.svg";